/* eslint-disable */
export const initDropdownPopupCancel = () => {
	const dropdowns = document.querySelectorAll(".dropdown-select-wrapper");

	if (!dropdowns || dropdowns.length === 0) return;

	dropdowns.forEach((wrapper) => {
		const btn = wrapper.querySelector(".dropdown-btn");
		const menu = wrapper.querySelector(".dropdown-menu");
		const buttonText = wrapper.querySelector(".dropdown-text");

		if (!btn || !menu) return;

		// Toggle dropdown visibility
		btn.addEventListener("click", (e) => {
			e.stopPropagation();
			menu.classList.toggle("hidden");
			menu.classList.toggle("flex");
		});

		// Handle reason selection
		const items = menu.querySelectorAll("[data-reason]");
		items.forEach((item) => {
			item.addEventListener("click", (e) => {
				e.stopPropagation();
				const reason = item.getAttribute("data-reason");
				buttonText.textContent = reason;
				menu.classList.add("hidden");
				menu.classList.remove("flex");
			});
		});
	});

	// Close dropdown when clicking outside
	document.addEventListener("click", () => {
		const dropdowns = document.querySelectorAll(".dropdown-menu");
		dropdowns.forEach((menu) => {
			menu.classList.add("hidden");
			menu.classList.remove("flex");
		});
	});
};
